//პროდაქშენზე უნდა იყოს ცარიელი
//export const getBaseUrl = () => "";
//ლოკალზე გაშვებისას უნდა იყოს ქვემოთ როგორცაა ისე
export const getBaseUrl = () => "https://mobilestore.ge";
